<template>
  <div>
    <paginated-data-table
      ref="table"
      :headers="headers"
      :search="search"
      :query="query"
      :custom-items-per-page="5"
      queryName="operationLogs"
      :queryVariables="queryVariables"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>
            {{ item.delta.find((field) => field.field === 'points.total').old.value }}
          </td>
          <td>
            {{ item.delta.find((field) => field.field === 'points.total').new.value }}
          </td>
          <td>
            {{ item.user.login }}
          </td>
          <td>
            {{ item.created_at | date({ fmtIn: 'yyyy-MM-dd HH:mm:ss', fmtOut: 'dd/MM/yyyy | HH:mm:ss' }) }}
          </td>
        </tr>
      </template>
    </paginated-data-table>
  </div>
</template>

<script>
import { QUERY_GET_LOGS } from '@/modules/clientes/gerenciamento/graphql'
import { createCsvFromArray } from '@/config/helpers.js'
import { DateTime } from 'luxon'
export default {
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },
  props: {
    user: Object,
  },
  data: () => ({
    search: null,
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Pontos antes',
          value: 'delta.points.total.old',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Pontos depois',
          value: 'delta.points.total.new',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Alterado por',
          value: 'user.login',
          width: '30%',
          sortable: false,
        },
        {
          text: 'Data',
          value: 'created_at',
          width: '30%',
          sortable: false,
        },
      ]
    },
    query() {
      return QUERY_GET_LOGS
    },
    queryVariables() {
      return {
        mutation: 'adjustPoints',
        fieldFilters: [
          {
            key: 'document_no',
            value: this.user.document_no,
          },
        ],
      }
    },
  },
  methods: {
    async exportCSV() {
      const { data } = await this.$apollo.query({
        query: this.query,
        variables: this.queryVariables,
        fetchPolicy: 'no-cache',
      })
      const rows = data.operationLogs.operationLogs.map((logs) => ({
        pontos_antes: logs.delta.points.total.old,
        pontos_depois: logs.delta.points.total.new,
        login: logs.user.login,
        data: DateTime.fromFormat(logs.created_at, 'yyyy-MM-dd HH:mm:ss').toFormat('dd/MM/yyyy HH:mm:ss'),
      }))
      const headers = ['Pontos antes', 'Pontos depois', 'Alterado por', 'Data']
      createCsvFromArray(rows, `historico_alteracoes_pontos_${this.user.document_no}`, headers)
    },
  },
}
</script>
